// // import React, { useEffect } from 'react';
// // import { Card, CardContent, Typography, Button, Grid, Divider, Box } from '@mui/material';
// // import UserHeader from '../UserComponent/UserHeader';
// // import failed_icon from "../../images/failed_icon.png";
// // import payCallIcon from "../../images/payCallIcon.png";
// // import payEmailIcon from "../../images/payEmailIcon.png";
// // import { useLocation, useNavigate } from 'react-router-dom';

// // // export const Failed = () => {
// //     export const Failed = ({ isModal = false, data, onClose }) => {

// //     const navigate = useNavigate();
// //     // const location = useLocation();
// //     // const { package: selectedPackage, payment_id } = location.state || {};

// //     const selectedPackage = data?.package;
// // const payment_id = data?.payment_id;

// //     const email = localStorage.getItem('email');




// //     return (
// //         <div>
// //             <UserHeader />
// //             <Box sx={{ px: 2 }}>
// //                 <Grid
// //                     container
// //                     justifyContent="center"
// //                     alignItems="center"
// //                     sx={{ minHeight: '100vh' }}
// //                 >
// //                     <Grid item xs={12} sm={10} md={8} lg={6}>
// //                         <Card elevation={4} sx={{ p: { xs: 2, sm: 3, md: 4 } }}>
// //                             <CardContent>
// //                                 <Box textAlign="center" mb={3}>
// //                                     <img
// //                                         src={failed_icon}
// //                                         alt="Payment Icon"
// //                                         style={{ maxWidth: '80px', marginBottom: '20px' }}
// //                                     />
// //                                     <Typography
// //                                         variant="h5"
// //                                         gutterBottom
// //                                         className="orderTitlet payFail"
// //                                     >
// //                                         Oops! Payment Failed
// //                                     </Typography>
// //                                     <Typography
// //                                         variant="subtitle1"
// //                                         color="textSecondary"
// //                                         className="paymentID"
// //                                     >
// //                                         We couldn’t complete your payment.
// //                                     </Typography>
// //                                     <Typography
// //                                     variant="subtitle2"
// //                                         color="textSecondary"
// //                                         className="paymentID">
// //                                         Your payment could not be processed due to a technical issue. Please try again later or use a different payment method.


// //                                     </Typography>
// //                                 </Box>

// //                                 <Divider sx={{ my: 3 }} />

// //                                 <Box
// //                                     display="flex"
// //                                     flexDirection={{ xs: 'column', sm: 'row' }}
// //                                     justifyContent="space-between"
// //                                     alignItems="center"
// //                                     mb={2}
// //                                     sx={{ gap: 2 }}
// //                                 >
// //                                     <Typography
// //                                         variant="h6"
// //                                         className="planTxt"
// //                                         sx={{ textAlign: { xs: 'center', sm: 'left' } }}
// //                                     >
// //                                         {selectedPackage?.package_name} Plan for{' '}
// //                                         {selectedPackage?.valid_period} Months
// //                                     </Typography>
// //                                     <Typography
// //                                         variant="h6"
// //                                         className="planTxt"
// //                                         sx={{ textAlign: { xs: 'center', sm: 'right' } }}
// //                                     >
// //                                         ₹ {selectedPackage?.package_price}
// //                                     </Typography>
// //                                 </Box>
// //                                 <Box
// //                                     display="flex"
// //                                     flexDirection={{ xs: 'column', sm: 'row' }}
// //                                     justifyContent="space-between"
// //                                     alignItems="center"
// //                                     sx={{ gap: 2 }}
// //                                 >
// //                                     <Typography
// //                                         variant="h6"
// //                                         className="planTxtYellow"
// //                                         sx={{ textAlign: { xs: 'center', sm: 'left' } }}
// //                                     >
// //                                         Total Price
// //                                     </Typography>
// //                                     <Typography
// //                                         variant="h6"
// //                                         className="planTxtYellow"
// //                                         sx={{ textAlign: { xs: 'center', sm: 'right' } }}
// //                                     >
// //                                         ₹ {selectedPackage?.package_price}
// //                                     </Typography>
// //                                 </Box>
// //                                 <Divider sx={{ my: 3 }} />

// //                                 <Typography
// //                                     variant="h6"
// //                                     textAlign="center"
// //                                     className="queriesTxt"
// //                                 >
// //                                     For any further queries
// //                                 </Typography>
// //                                 <Box
// //                                     display="flex"
// //                                     flexDirection={{ xs: 'column', sm: 'row' }}
// //                                     justifyContent="center"
// //                                     alignItems="center"
// //                                     gap={2}
// //                                     mt={1}
// //                                     sx={{ textAlign: 'center' }}
// //                                 >
// //                                     <Typography variant="body1">
// //                                         <img
// //                                             src={payCallIcon}
// //                                             alt="Phone Icon"
// //                                             style={{
// //                                                 verticalAlign: 'middle',
// //                                                 marginRight: '8px',
// //                                             }}
// //                                         />
// //                                         +918600555740
// //                                     </Typography>
// //                                     <Typography variant="body1">
// //                                         <img
// //                                             src={payEmailIcon}
// //                                             alt="Email Icon"
// //                                             style={{
// //                                                 verticalAlign: 'middle',
// //                                                 marginRight: '8px',
// //                                             }}
// //                                         />
// //                                         support@indmatrimony.in
// //                                     </Typography>
// //                                 </Box>

// //                                 <Box textAlign="center" mt={4}>
// //                                     <Button
// //                                         variant="contained"
// //                                         color="primary"
// //                                         // href="/upgrade"
// //                                         onClick={() => navigate("/upgrade", { replace: true })}

// //                                         size="large"
// //                                     >
// //                                         Try Again
// //                                     </Button>
// //                                 </Box>
// //                             </CardContent>
// //                         </Card>
// //                     </Grid>
// //                 </Grid>
// //             </Box>
// //         </div>
// //     );
// // };










import React from "react";
import {
  Box,
  Typography,
  Button,
  Divider,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";

import paymentFailedAnimation from "../../images/Failed.json";
import payCallIcon from "../../images/payCallIcon.png";
import payEmailIcon from "../../images/payEmailIcon.png";

export const Failed = ({ isModal = false, data, onClose }) => {
  const navigate = useNavigate();
  const selectedPackage = data?.package;

    const montserratTypography = {
  "& .MuiTypography-root": {
    fontFamily: "'Montserrat', sans-serif",
  },
};


  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...montserratTypography,
      }}
    >
      {/* Modal Container */}
      <Box
        sx={{
          position: "relative",
        //    width: modalWidth ,
                    width: {
      xs: "95%",   // 0–600px
      sm: "85%",   // 600–768px
      md: "55%",   // 768–1024px
      lg: "40%",   // 1024–1400px
      xl: "35%",   // 1400px+
    },
          backgroundColor: "#fff",
          borderRadius: "22px",
          padding: "32px 24px",
          textAlign: "center",
          boxShadow: "0px 20px 40px rgba(0,0,0,0.2)",
          overflow: "hidden",

          // 🔥 FONT FIX (one line, applies to everything)
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        {/* 🔴 Top Gradient Curve */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "180px",
            background:
              "linear-gradient(180deg, #efbcc0 0%, #FFF 75%)",
            borderBottomLeftRadius: "100% 45%",
            borderBottomRightRadius: "100% 45%",
            zIndex: 0,
          }}
        />

        {/* Foreground Content */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          {/* Close */}
          {isModal && (
            <IconButton
              onClick={onClose}
              sx={{ position: "absolute", top: 0, right: 0 }}
            >
              <CloseIcon />
            </IconButton>
          )}

          {/* 🔴 Failed Animation */}
          {/* <Box sx={{ width: 100, mx: "auto", mb: 1 }}>
            <Lottie animationData={paymentFailedAnimation} loop={true} />
          </Box> */}

          <Box
  sx={{
    width: { xs: 120, sm: 140, md: 140 }, // responsive
    height: { xs: 120, sm: 140, md: 140 },
    mx: "auto",
    mb: 1,
  }}
>
  <Lottie
    animationData={paymentFailedAnimation}
    loop
    style={{ width: "100%", height: "100%" }}
  />
</Box>


          <Typography
            sx={{
              fontSize: 22,
              fontWeight: 700,
              color: "#EF4444",
              mb: 1,
            }}
          >
            Oops! Payment Failed
          </Typography>

          <Typography sx={{ color: "#666", fontWeight: 500, mb: 0.5 }}>
            We couldn’t complete your payment
          </Typography>

          <Typography sx={{ fontSize: 14, color: "#888", mb: 3 }}>
            Your payment could not be processed due to a technical issue.
            Please try again later or use a different payment method.
          </Typography>

          {/* Plan Card */}
          <Box
            sx={{
              border: "1px solid #E5E7EB",
              borderRadius: "14px",
              padding: "14px 16px",
              mb: 3,
              backgroundColor: "#fff",
            }}
          >
            <Typography
              sx={{
                fontSize: 12,
                color: "#999",
                mb: 0.5,
                textAlign: "left",
                fontWeight: 500,
              }}
            >
              SELECTED PLAN
            </Typography>

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography sx={{ fontWeight: 600 }}>
                {selectedPackage?.package_name} Plan for{" "}
                {selectedPackage?.valid_period} Months
              </Typography>

              <Typography sx={{ fontWeight: 700 }}>
                ₹ {selectedPackage?.package_price}
              </Typography>
            </Box>

            <Divider sx={{ my: 1.2, borderColor: "#00000030" }} />

            <Box display="flex" justifyContent="space-between">
              <Typography sx={{ color: "#555", fontWeight: 500 }}>
                Total Amount
              </Typography>
              <Typography sx={{ fontWeight: 700, color: "#2563EB" }}>
                ₹ {selectedPackage?.package_price}
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ mb: 2, borderColor: "#00000030" }} />

          <Typography sx={{ fontSize: 14, mb: 1 }}>
            Need help? Talk to our support team.
          </Typography>

          <Box
            display="flex"
            justifyContent="center"
            gap={3}
            sx={{ fontSize: 14 }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <img src={payCallIcon} alt="call" width={18} />
              +91 8600555740
            </Box>

            <Box display="flex" alignItems="center" gap={1}>
              <img src={payEmailIcon} alt="email" width={18} />
              support@indmatrimony.in
            </Box>
          </Box>

          <Button
            fullWidth
            sx={{
              mt: 3,
              height: 48,
              borderRadius: "999px",
              fontWeight: 600,
              fontFamily: "'Montserrat', sans-serif", // 🔥 ensure button text
              backgroundColor: "#1D4ED8",
            }}
            variant="contained"
            // onClick={() => navigate("/upgrade", { replace: true })}
            onClick={onClose}
          >
            Try Again
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
